import axios from 'axios';
import { config } from '../../config';

export default {
    namespaced: true, // ← IMPORTANTE: Activa el namespacing para este módulo

    actions: {
        async reserva_getAll() {
            return new Promise((resolve, reject) => {
                axios.get(config.apiUrl + '/reserva/get-all')
                    .then(
                        response => {
                            resolve(response);
                        })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async reserva_store(_, formData) {
            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl + '/reserva/store', formData)
                    .then(
                        response => {
                            resolve(response);
                        })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async reserva_cancelar(_, formData) {
            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl + '/reserva/cancelar', formData)
                    .then(
                        response => {
                            resolve(response);
                        })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async reserva_updateObservacion(_, formData) {
            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl + '/reserva/update-observacion', formData)
                    .then(
                        response => {
                            resolve(response);
                        })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async reserva_updateMontoReserva(_, formData) {
            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl + '/reserva/update-monto-reserva', formData)
                    .then(
                        response => {
                            resolve(response);
                        })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
        async reserva_updateStatus(_, formData) {
            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl + '/reserva/update-status', formData)
                    .then(
                        response => {
                            resolve(response);
                        })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        }
    }
}